import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CancelPrescriptionUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(
    patientUuid: string,
    prescriptionUuid: string,
  ): Promise<SATResult<void, SATError>> {
    return this.prescriptionRepo.cancelPrescription(patientUuid, prescriptionUuid);
  }
}
